export const roles = {
  technician: {
    key: 'tmm_technician',
    label: 'Technician',
  },
  facility_manager: {
    key: 'tmm_manager',
    label: 'Facility Manager',
  },
  trane_admin: {
    key: 'tmm_admin',
    label: 'Trane Admin',
  },
  observer: {
    key: 'observer',
    label: 'Observer',
  },
} as const;

export const rolesList = Object.values(roles);
